// Push setup is optional and must never interrupt login/logout.
export function syncPushAccount(employeeId = getCurrentEmployeeId()) {
  try {
    if (typeof navigator === 'undefined' || !navigator.serviceWorker) return;
    const message = { type:'CHAT_SET_CURRENT_EMPLOYEE', employee_id:Number(employeeId)||0 };
    try { navigator.serviceWorker.controller?.postMessage(message); } catch (_) {}
    Promise.resolve(navigator.serviceWorker.ready)
      .then(reg => { try { reg?.active?.postMessage(message); } catch (_) {} })
      .catch(() => {});
  } catch (_) {}
}
try {
  if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener('controllerchange', () => syncPushAccount());
  }
} catch (_) {}
if (typeof window !== 'undefined') window.addEventListener('storage', event => {
  if (event.key === 'token' || event.key === null) syncPushAccount();
});
export function getToken() {
  return localStorage.getItem('token') || '';
}

export function setAuth(token, user) {
  localStorage.setItem('token', token);
  if (user) localStorage.setItem('user', JSON.stringify(user));
  syncPushAccount();
}

export function clearAuth() {
  syncPushAccount(0);
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

export function getSavedUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
}

export function isTokenExpired(token = getToken()) {
  // 시간 경과만으로는 자동 로그아웃하지 않습니다.
  // 토큰이 존재하면 앱 진입을 허용하고, 계정 유효성은 API 서버가 확인합니다.
  return !token;
}

export function getCurrentEmployeeId() {
  try {
    const token = getToken();
    const body = token.split('.')[1];
    if (!body) return null;
    const parsed = JSON.parse(atob(body.replace(/-/g, '+').replace(/_/g, '/')));
    return Number(parsed.id || parsed.employee_pk || parsed.employeeId || 0) || null;
  } catch {
    return null;
  }
}
